if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
	        this.elements = {
	          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
	          viewer: this.querySelector('[id^="GalleryViewer"]'),
	          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
	          previousButton: this.querySelector('[data-chef-media-prev]'),
	          nextButton: this.querySelector('[data-chef-media-next]'),
	          mobileCurrent: this.querySelector('[data-chef-media-current]'),
	          mobileTotal: this.querySelector('[data-chef-media-total]'),
	          mobileProgressItems: this.querySelectorAll('[data-chef-media-progress]'),
	        };
	        this.mql = window.matchMedia('(min-width: 750px)');
	        if (!this.elements.viewer) return;

	        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
	        if (this.elements.thumbnails) {
	          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
	            var button = mediaToSwitch.querySelector('button');
	            if (button) button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
	          });
	        }
	        if (this.elements.previousButton) this.elements.previousButton.addEventListener('click', () => this.showAdjacentMedia(-1));
	        if (this.elements.nextButton) this.elements.nextButton.addEventListener('click', () => this.showAdjacentMedia(1));
	        this.loadDeferredMediaImage(this.elements.viewer.querySelector('.product__media-item.is-active'));
	        this.observeDeferredMediaImages();
	        this.updateChefMediaNav();
	        this.updateChefMobileStatus();
	        if (this.elements.thumbnails && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
	      }

      onSlideChanged(event) {
        this.loadDeferredMediaImage(event.detail.currentElement);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('is-active', element === event.detail.currentElement);
        });
        const thumbnail = this.elements.thumbnails
          ? this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`)
          : null;
        if (thumbnail) this.setActiveThumbnail(thumbnail);
        this.updateChefMediaNav();
        this.updateChefMobileStatus();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
	        activeMedia.classList.add('is-active');
	        this.loadDeferredMediaImage(activeMedia);
	        this.updateChefMediaNav();
	        this.updateChefMobileStatus();

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
	        this.announceLiveRegion(activeMedia, activeThumbnail ? activeThumbnail.dataset.mediaPosition : this.getActiveMediaIndex() + 1);
	      }

	      showAdjacentMedia(direction) {
	        const items = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
	        if (items.length < 2) return;

	        const activeIndex = this.getActiveMediaIndex(items);
	        const nextIndex = activeIndex + direction;
	        if (nextIndex < 0 || nextIndex >= items.length) return;
	        this.setActiveMedia(items[nextIndex].dataset.mediaId, false);
	      }

	      getActiveMediaIndex(items = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'))) {
	        return Math.max(
	          0,
	          items.findIndex((item) => item.classList.contains('is-active'))
	        );
	      }

	      updateChefMediaNav() {
	        const items = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
	        if (items.length < 2) {
	          if (this.elements.previousButton) this.elements.previousButton.setAttribute('hidden', '');
	          if (this.elements.nextButton) this.elements.nextButton.setAttribute('hidden', '');
	          return;
	        }

	        const activeIndex = this.getActiveMediaIndex(items);
	        if (this.elements.previousButton) this.elements.previousButton.toggleAttribute('hidden', activeIndex === 0);
	        if (this.elements.nextButton) this.elements.nextButton.toggleAttribute('hidden', activeIndex === items.length - 1);
	      }

	      updateChefMobileStatus() {
	        const items = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
	        if (!items.length || !this.elements.mobileCurrent || !this.elements.mobileTotal) return;

	        const activeIndex = this.getActiveMediaIndex(items);
	        const format = (value) => String(value).padStart(2, '0');
	        this.elements.mobileCurrent.textContent = format(activeIndex + 1);
	        this.elements.mobileTotal.textContent = format(items.length);
	        this.elements.mobileProgressItems.forEach((item, index) => {
	          item.classList.toggle('is-active', index === activeIndex);
	        });
	      }

	      loadDeferredMediaImage(mediaItem) {
        if (!mediaItem) return;
        const image = mediaItem.querySelector('img.product__media-deferred-image[data-src]');
        if (!image) return;

        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-sizes');
      }

      observeDeferredMediaImages() {
        if (!('IntersectionObserver' in window) || !this.elements.viewer || !this.elements.viewer.slider) {
          this.elements.viewer
            .querySelectorAll('.product__media-item')
            .forEach((mediaItem) => this.loadDeferredMediaImage(mediaItem));
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.loadDeferredMediaImage(entry.target);
              observer.unobserve(entry.target);
            });
          },
          {
            root: this.elements.viewer.slider,
            rootMargin: '200px',
          }
        );

        this.elements.viewer.querySelectorAll('.product__media-item').forEach((mediaItem) => {
          if (mediaItem.classList.contains('is-active')) return;
          observer.observe(mediaItem);
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (typeof this.elements.thumbnails.isSlideVisible === 'function' && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.elements.thumbnails.slider) this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion || !window.accessibilityStrings || !window.accessibilityStrings.imageAvailable) return;
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
